module.exports = __webpack_public_path__ + "img/sort-asc.94eb803e.svg";